// extracted by mini-css-extract-plugin
export default {"gameEndContainer":"Gi83gZcnug__nJjuLZ_Z","container":"xBGEI1RwUspIbyfVf6Cg","confetti":"_MKBfzsSZF5d1fHSqPXH"};